var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.175 0.0108931C38.0046 -0.00363102 37.8329 -0.00363102 37.6625 0.0108931H2.6625C2.43818 0.0137524 2.21535 0.0415778 2 0.0936198L20.0625 14.9741L38.175 0.0108931Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.85 1.61914L21.65 16.6134C21.1816 16.9986 20.548 17.2148 19.8875 17.2148C19.227 17.2148 18.5934 16.9986 18.125 16.6134L0.0875001 1.73289C0.0320493 1.90149 0.00264836 2.07522 0 2.24993V22.9316C0 23.4802 0.263392 24.0062 0.732233 24.3941C1.20107 24.7819 1.83696 24.9998 2.5 24.9998H37.5C38.163 24.9998 38.7989 24.7819 39.2678 24.3941C39.7366 24.0062 40 23.4802 40 22.9316V2.24993C39.9901 2.03449 39.9394 1.82165 39.85 1.61914ZM4.2125 22.9316H2.475V21.4529L11.5625 13.9971L13.325 15.4552L4.2125 22.9316ZM37.475 22.9316H35.725L26.6125 15.4552L28.375 13.9971L37.4625 21.4529L37.475 22.9316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.7d05c56fb5bf1c01467e97fac9c7bb6d.svg";
export { ForwardRef as ReactComponent };